export function PrivacyPage() {
  return (
    <article className="card space-y-4 leading-relaxed">
      <h1 className="text-2xl font-bold">개인정보 처리방침</h1>
      <p>
        모당(임시 명칭, 이하 "서비스")은 예약 진행에 필요한 최소한의 개인정보만 수집·이용합니다.
      </p>
      <h2 className="text-xl font-semibold">수집 항목</h2>
      <ul className="list-disc pl-5">
        <li>고객: 이름, 생년월일, 휴대전화번호, 성별</li>
        <li>예약·결제 정보, 취소 시 환불 계좌</li>
      </ul>
      <h2 className="text-xl font-semibold">이용 목적</h2>
      <ul className="list-disc pl-5">
        <li>예약 접수·확정·안내, 결제·환불, 알림 발송</li>
      </ul>
      <h2 className="text-xl font-semibold">보유 기간</h2>
      <p>예약일로부터 1년 후 자동 익명화 처리합니다.</p>
      <h2 className="text-xl font-semibold">문의</h2>
      <p>운영자: development@rhoonart.com</p>
    </article>
  );
}
